import { render, staticRenderFns } from "./PaymentCard.vue?vue&type=template&id=0636ad12&scoped=true"
import script from "./PaymentCard.vue?vue&type=script&lang=js"
export * from "./PaymentCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentCard.vue?vue&type=style&index=0&id=0636ad12&prod&lang=scss&scoped=true"
import style1 from "./PaymentCard.vue?vue&type=style&index=1&id=0636ad12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0636ad12",
  null
  
)

export default component.exports